import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-black text-foreground-900">常见问题</h2>
        </div>

        <div className="flex flex-col gap-3">
          {faqItems.map((faq) => (
            <div
              key={faq.id}
              className="p-5 rounded-xl bg-background-100 border border-background-200/70"
            >
              <h3 className="text-base font-bold text-foreground-800 mb-2 flex items-center gap-2">
                <i className="ri-question-answer-line text-primary-500 flex-shrink-0"></i>
                {faq.question}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed pl-7">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}